import {
  TextCardParamsSchema,
  defaultTextCardParams,
  type TextCardParams,
} from "@playbookai/widget-schemas";
import type { YjsWidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { paramsFromYMap, paramsToYMap } from "../yjs-params.js";
import { TextCardWidget } from "./Component.js";

/** Free-text fields stored as `Y.Text` for char-level merge (PB-418). */
const TEXT_FIELDS = ["title", "body"] as const;

export const textCardDef: YjsWidgetDef<TextCardParams> = {
  kind: "textCard",
  label: "Text card",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 280, h: 200 },
  defaultParams: defaultTextCardParams,
  Component: TextCardWidget,
  storage: "yjs",
  accent: "neutral",
  textFields: TEXT_FIELDS,
  // Defensive read: the Yjs render path does no schema validation, so a
  // malformed/legacy stored value coerces to defaults rather than throwing.
  paramsFromY: (raw) =>
    paramsFromYMap(raw, TextCardParamsSchema, defaultTextCardParams),
  paramsToY: (next) =>
    paramsToYMap(next as Record<string, unknown>, TEXT_FIELDS),
};

registerWidget(textCardDef);
